<template>
  <div class="modal">
    <div class="modal__bg" @click="$emit('onModalClose')"></div>
    <div class="modal__body">
      <h4 class="modal__header mb-3">
        <span>Report An Issue</span>
        <img
          src="~@/assets/media/icons/close.svg"
          alt="close icon"
          @click="$emit('onModalClose')"
        />
      </h4>
      <div v-if="step === 1">
        <div
          v-if="
            isMainSupportOption.length && isMainSupportOption[0].value.status
          "
        >
          <p class="support-label">
            <span class="badge" :style="{ borderColor: primary }">1</span>
            Select your issue
          </p>
          <div class="row -amenities">
            <template v-for="amenity in isSubSupportOption">
              <div
                class="col-md-3 amenity-col"
                :key="amenity.id"
                v-if="amenity.value.status"
              >
                <div
                  class="o-amenities"
                  :class="{ '-selected': amenity.id === selectedAmenity.id }"
                  :style="{
                    backgroundColor:
                      amenity.id === selectedAmenity.id ? primary : '#fff'
                  }"
                  @click="
                    handleSelectAmenity({
                      amenity,
                      image: amenities[amenity.label].image
                    })
                  "
                  @mouseenter="handleMouseHover(true, $event)"
                  @mouseleave="handleMouseHover(false, $event)"
                >
                  <div class="o-amenities__icon">
                    <img
                      :src="amenities[amenity.label].image"
                      :alt="amenities[amenity.label].name + 'icon'"
                    />
                  </div>
                  {{ amenity.label }}
                </div>
              </div>
            </template>
          </div>
          <div class="row">
            <div class="col">
              <div v-if="locations">
                <div class="select-wrapper d-flex flex-wrap">
                  <p class="support-label m-0">
                    <span class="badge" :style="{ borderColor: primary }">
                      2
                    </span>
                    <span class="label">Select your location</span>
                  </p>
                  <div class="align-items-center d-flex location">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="32"
                      height="32"
                      class="mr-2"
                    >
                      <path
                        :fill="primary"
                        d="M25.444 6.722C23.272 3.583 19.827 1.778 16 1.778S8.728 3.584 6.561 6.722C4.4 9.85 3.9 13.811 5.222 17.305c.356.956.917 1.883 1.667 2.75l8.356 9.811c.189.222.467.35.756.35s.567-.128.756-.35l8.356-9.806c.756-.872 1.317-1.8 1.667-2.75 1.322-3.5.822-7.461-1.333-10.589zm-.527 9.895c-.272.733-.711 1.456-1.311 2.15l-.006.006-7.6 8.922-7.6-8.928c-.6-.694-1.039-1.417-1.317-2.156-1.094-2.894-.678-6.167 1.111-8.756 1.794-2.6 4.639-4.089 7.806-4.089s6.011 1.489 7.806 4.089c1.789 2.589 2.206 5.861 1.111 8.761z"
                      />
                      <path
                        :fill="primary"
                        d="M16 7.678c-3.072 0-5.572 2.5-5.572 5.572s2.5 5.572 5.572 5.572 5.572-2.5 5.572-5.572-2.5-5.572-5.572-5.572zm0 9.15c-1.972 0-3.578-1.606-3.578-3.578S14.028 9.667 16 9.667s3.578 1.606 3.578 3.578-1.606 3.583-3.578 3.583z"
                      />
                    </svg>
                    <CustomSelect
                      :options="locations"
                      :placeholder="'Select a location'"
                      v-model="supportLocation"
                      @handleOptions="fetchLocations"
                      name="category"
                      :config="{
                        displaySize: 4
                      }"
                    />
                  </div>
                  <div>
                    <div
                      v-if="products.length >= 1"
                      class="d-flex align-items-center"
                    >
                      <span>in</span>
                      <CustomSelect
                        :options="products"
                        :placeholder="'Select a product'"
                        v-model="supportProduct"
                        @handleOptions="handleProducts"
                        :searchable="true"
                        class="select-location"
                        :config="{
                          displaySize: 4
                        }"
                      />
                    </div>
                  </div>
                  <Spinner
                    v-if="fetching"
                    style="margin-left: 10px;"
                    :theme="primary"
                  />
                </div>
              </div>
              <Spinner v-else />
            </div>
          </div>
        </div>

        <Spinner v-else :theme="primary" class="mx-auto d-block" />
      </div>
      <div v-if="step === 2" class="step-2">
        <div class="d-flex">
          <img
            class="mr-10"
            :src="supportIssueIcon"
            :alt="selectedAmenity.label + ' icon'"
          />
          {{ selectedAmenity.label }}
          at {{ supportLocation.label }}
          {{ supportProduct ? "in " + supportProduct.label : "" }}
        </div>
        <div class="form-group">
          <p class="support-label d-flex align-items-center">
            <span class="badge" :style="{ borderColor: primary }">3</span>
            <span>Tell us what's going on and we'll assist you right away</span>
          </p>
          <textarea
            name="desc"
            v-model="description"
            placeholder="Describe your issue"
            cols="30"
            rows="10"
            class="form-control mt-10"
          ></textarea>
        </div>
      </div>
      <div class="action-wrapper d-flex justify-content-end">
        <div>
          <ActionButton
            label="Next"
            :theme="{ primary, secondary, event, danger }"
            v-if="
              step === 1 &&
                supportLocation &&
                Object.keys(selectedAmenity).length >= 1
            "
            @customEvent="step++"
            style="width: auto; margin-top: 10px"
          />
          <div v-else style="height: 35px; width: 100%;"></div>
        </div>
        <ActionButton
          label="Back"
          :theme="{ primary, secondary, event, danger }"
          v-if="step === 2 && supportLocation && !loading"
          @customEvent="step--"
          style="width: auto; margin-right: 5px; margin-top: 10px"
        />

        <ActionButton
          label="Submit"
          :theme="{ primary, secondary, event, danger }"
          v-if="step === 2 && !loading"
          @customEvent="handleSupportSubmit"
          style="width: auto; margin-top: 10px"
        />
        <Spinner
          style="display: block;float:right"
          :theme="primary"
          v-if="loading"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ActionButton from "@/components/ActionButton";
import axios from "@/helpers/base";
import _ from "lodash";
import { reportAnIssueMailer } from "@/helpers/mailer";
import CustomSelect from "@/components/Select";

const Spinner = () => import("@/components/Spinner");

export default {
  name: "UserSupport",
  components: {
    Spinner,
    ActionButton,
    CustomSelect
  },
  data() {
    return {
      loading: false,
      modalName: "",
      description: "",
      amenities: {
        WiFi: {
          id: 1,
          name: "WiFi",
          image: require("@/assets/media/icons/wifi.svg")
        },
        Printer: {
          id: 2,
          name: "Printer",
          image: require("@/assets/media/icons/printer.svg")
        },
        Equipment: {
          id: 3,
          name: "Equipment",
          image: require("@/assets/media/icons/equipment.svg")
        },
        Temperature: {
          id: 4,
          name: "Temperature",
          image: require("@/assets/media/icons/temp.svg")
        },
        Lighting: {
          id: 5,
          name: "Lighting",
          image: require("@/assets/media/icons/lighting.svg")
        },
        Noise: {
          id: 6,
          name: "Noise",
          image: require("@/assets/media/icons/noise.svg")
        },
        Furniture: {
          id: 7,
          name: "Furniture",
          image: require("@/assets/media/icons/furniture.svg")
        },
        Cleanliness: {
          id: 8,
          name: "Cleanliness",
          image: require("@/assets/media/icons/cleanliness.svg")
        }
      },
      selectedAmenity: [],
      products: [],
      productMeta: {
        page: 1,
        hasNextPage: true
      },
      supportLocation: null,
      supportIssueIcon: null,
      supportProduct: null,
      fetching: false,
      step: 1,
      isMainSupportOption: {},
      isSubSupportOption: {}
    };
  },
  computed: {
    options() {
      return this.$store.state.concierge.optionsList.data;
    },
    primary() {
      return this.$store.state.app.scheme.primary;
    },
    secondary() {
      return this.$store.state.app.scheme.secondary;
    },
    event() {
      return this.$store.state.app.scheme.event;
    },
    danger() {
      return this.$store.state.app.scheme.danger;
    },
    user() {
      return this.$store.getters.getUser;
    },
    locations() {
      this.$store.state.admin.locations.map(location => {
        Object.assign(location, {
          label: location.name,
          value: location.id
        });
      });
      return this.$store.state.admin.locations;
    }
  },
  async created() {
    await this.$store.dispatch("fetchOptions", "support");

    let supportFilterMain = {
      key: "support.main"
    };
    this.isMainSupportOption = _.filter(this.options, supportFilterMain);
    let supportFilterSub = {
      key: "support.sub"
    };
    this.isSubSupportOption = _.filter(this.options, supportFilterSub);
  },
  mounted() {
    this.fetchLocations({ search: "" });
  },
  watch: {
    supportLocation: function(newVal) {
      this.fetching = true;
      this.products = [];
      this.handleProducts(newVal);
      this.supportProduct = null;
    }
  },
  methods: {
    handleSelectAmenity(amenityObj) {
      const { amenity, image } = amenityObj;

      this.selectedAmenity = amenity;
      this.supportIssueIcon = image;
      this.diselectAmenity();
    },
    diselectAmenity() {
      setTimeout(function() {
        let amenityCol = _.filter(
          document.querySelectorAll(".o-amenities"),
          function(amenity) {
            return !amenity.classList.contains("-selected");
          }
        );
        amenityCol.forEach(function(v, k) {
          amenityCol[k].style.backgroundColor = "#fff";
        });
      }, 100);
    },
    async fetchLocations(params) {
      let { search } = params;
      let action = search ? `search[name]=${search}` : "";
      await this.$store.dispatch("FETCH_LOCATION_PAGINATE", action);
    },
    /**
     * Fetch and filter `products` based on id of selected location then store results in `this.products`
     *
     * @param {object} params
     */
    async fetchProducts(params) {
      const { search, value } = params;
      const { page, hasNextPage } = this.productMeta;
      let action = search ? `&search[name]=${search}` : "";
      // replace url
      if (hasNextPage) {
        await axios
          .get(
            `/products?page[number]=${page}&page[size]=10&locationId=${value}&status=2${action}`
          )
          .then(res => {
            if (res.data.data.length >= 1) {
              this.products = res.data.data.map(e => ({
                value: e.id,
                label: e.name
              }));
            }
            this.productMeta.hasNextPage = res.data.meta.hasNextPage;
            this.productMeta.page++;
          })
          .catch(err => {
            console.error(err);
          });
      }
      this.fetching = false;
    },
    async handleProducts(params) {
      this.productMeta = {
        page: 1,
        hasNextPage: true
      };
      this.supportLocation.search = params.search;
      await this.fetchProducts(this.supportLocation);
    },
    async handleSupportSubmit() {
      this.loading = true;
      let message = {
        issue: this.selectedAmenity.label,
        location: this.supportLocation.label,
        product: this.supportProduct.label,
        description: this.description
      };
      let subject = "Report An Issue";
      await reportAnIssueMailer({ subject, message, user: this.user });
      this.$swal(
        "Submitted",
        "We got your request. We're on it.",
        "success"
      ).then(() => {
        this.loading = false;
        this.selectedAmenity = [];
        this.locations = null;
        this.supportLocation = null;
        this.supportIssue = null;
        this.supportProduct = null;
        this.step = 1;
        this.$emit("onModalClose");
      });
    },
    handleMouseHover(param, $event) {
      let target = $event.target.classList.contains("-selected");
      if (Object.keys(this.selectedAmenity).length == 0 && !target) {
        $event.target.style.backgroundColor = param ? this.primary : "#fff";
      } else if (!target) {
        $event.target.style.backgroundColor = param ? this.primary : "#fff";
      }
    }
  }
};
</script>

<style lang="scss" scoped>
/*  */

.h-0 {
  height: 0;
}
.modal {
  display: block;
  min-height: 100vh;
  left: 0;
  width: 100%;
  &__bg {
    background-color: black;
    height: 100%;
    left: 0;
    opacity: 0.5;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 0;
  }

  &__body {
    animation: fade-in-up 0.25s ease-out forwards;
    background-color: white;
    border-radius: 5px;
    left: 50%;
    max-height: 600px;
    overflow: visible;
    padding: 40px;
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 800px;
    z-index: 1;
    @media (max-width: 767px) {
      max-height: 500px;
      width: 300px;
      overflow: auto;
    }
    @media (max-width: 991px) and (orientation: landscape) {
      max-height: 300px;
      width: 650px;
      overflow: auto;
    }
    @media (min-width: 768px) and (max-width: 991px) and (orientation: portrait) {
      max-height: 700px;
      width: 600px;
      overflow: auto;
    }
    .support-label {
      color: $gray-900;
      font-family: $font-family-base;
      font-size: $font-size-sm;
      margin-bottom: 0;
      span {
        color: #232323;
        font-family: $font-family-base;
        font-size: $font-size-sm;
        font-weight: 400;
        &.badge {
          border: 2px solid $brand-primary;
          border-radius: 50%;
          height: 35px;
          margin: 0 10px 0 0;
          padding: 10px;
          width: 35px;
          @media (max-width: 663px) {
            margin-right: 0px;
            margin-left: 0px;
          }
        }
        &.label {
          @media (min-width: 663px) {
            display: none;
          }
        }
      }
      @media (max-width: 663px) {
        margin-bottom: 10px !important;
      }
    }
  }
  &__header {
    color: $gray-900;
    font-size: $font-size-base;
    margin-bottom: 0;
    position: relative;
    img {
      cursor: pointer;
      top: 0;
      position: absolute;
      right: 0;
    }
  }
  .-amenities {
    margin-top: 20px;
    .amenity-col {
      .o-amenities {
        border-radius: 6px;
        box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.07);
        color: #505050;
        cursor: pointer;
        margin-bottom: 30px;
        padding: 10px;
        position: relative;
        text-align: center;
        transition-duration: 0.5s;
        transition-property: background-color, transform;
        &:hover,
        &.-selected {
          background-color: var(--primary, $brand-primary);
          outline: none;
          transform: translateY(-10px);
          color: #fff;
          .o-amenities__icon {
            & > img {
              filter: brightness(0) invert(1);
            }
          }
          &::before {
            opacity: 1;
            transform: translate(10%, 10px);
          }

          @media (max-width: 767px) {
            transform: translateY(0);
            &::before {
              transform: translate(0);
            }
          }
        }
        &::before {
          background: radial-gradient(
            ellipse at center,
            rgba(0, 0, 0, 0.15) 0%,
            rgba(0, 0, 0, 0) 80%
          );
          content: "";
          display: block;
          height: 10px;
          opacity: 0;
          pointer-events: none;
          position: absolute;
          top: 100%;
          left: 0;
          transform: translate(10%, 0px);
          transition-property: transform, opacity;
          transition-duration: 0.5s;
          width: 80%;
        }
        &__icon {
          display: flex;
          align-items: center;
          height: 45px;
          margin-bottom: 25px;
          text-align: center;
          width: auto;
          & > img {
            height: 35px;
            margin: 0 auto;
            width: 100%;
            filter: invert(70%);
          }
        }
      }
    }
  }
}

@keyframes fade-in-up {
  0% {
    opacity: 0;
    top: 44%;
  }
  100% {
    opacity: 1;
    top: 50%;
  }
}

@keyframes fade-in-up {
  0% {
    opacity: 0;
    top: 44%;
  }
  100% {
    opacity: 1;
    top: 50%;
  }
}
</style>

<style lang="scss">
.select-wrapper {
  align-items: center;
  p {
    margin-bottom: 0;
    margin-right: 10px;
  }
  img {
    height: 20px;
    margin-right: 5px;
    width: 20px;
  }
  span {
    font-size: $font-size-xs;
    margin-left: 10px;
    margin-right: 10px;
    @media (max-width: 663px) {
      margin-left: 12px;
      margin-right: 13px;
    }
  }
  .v-select {
    min-width: 180px;
    @media (min-width: 663px) {
      min-width: 200px;
    }
    &.select-location {
      @media (min-width: 992px) {
        min-width: 300px;
      }
    }
    .dropdown-toggle {
      min-height: 32px;
      overflow: hidden;
    }

    ul.dropdown-menu {
      width: auto;
    }
  }
  .location {
    @media (max-width: 662px) {
      margin-bottom: 10px;
    }
  }
}

.step {
  &-2 {
    p {
      color: $brand-primary;
      font-family: "Gotham";
      font-size: $font-size-sm;
      margin-bottom: 10px;
      img {
        margin-right: 10px;
      }
      span {
        font-family: "Gotham";
        font-weight: 700;
      }
    }
    .form-group {
      margin-top: 14px;
      textarea {
        &.form-control {
          height: 100px;
        }
      }
    }
  }
}
</style>
